setTimeout(stockValidation("refresh"), 200);
//stock validation
function stockValidation(callfrom){
 console.log("---------STOCK VALIDATION-------------");
 console.log("call from ", callfrom);

 var selectOptionPopupDiv = document.getElementById("selectOptionPopup");

 //Which page
 var pageType = '';
 if (window.location.pathname.indexOf('/products/') == 0) {
    pageType = 'products'; //its productpage
 }else if(window.location.pathname.indexOf('/collections/') == 0){
    pageType = 'collections';
 }else{
    pageType = 'others';
 }
 console.log("pageType", pageType);

 var leftEyeDiv = document.getElementsByClassName("left-eye-option"); 
 var rightEyeDiv = document.getElementsByClassName("pg__option__v");
 var productFormItem = document.getElementsByClassName('product-form__item');
 var pid = '';

 if(selectOptionPopupDiv != null ){
    if(selectOptionPopupDiv.style.display == 'block' ){
        pid = selectOptionPopupDiv.getElementsByClassName('product-form__item')[0].getAttribute('pid');
    }else{
        pid = document.getElementsByClassName('product-form__item')[0].getAttribute('pid');
    }
 }else{
    if(productFormItem.length > 0){
      pid = document.getElementsByClassName('product-form__item')[0].getAttribute('pid');
    }
 }

 if (leftEyeDiv.length > 0){
    console.log("product highlights", pid);

    /*do reset*/
    document.getElementsByClassName('button--single-cart-main')[0].style.cursor = "pointer";
    document.getElementsByClassName('button--single-cart-main')[0].disabled = false;  
    hideAlert();

    var leftEyeChoice = ''
    var rightEyeChoice = ''
    var leftVariantOpt = ''
    var rightVariantOpt = ''
    var leftStockRecord = 0;
    var rightStockRecord = 0;
    var remainingStockLeft = 0;
    var remainingStockRight = 0;
    var strQuantity = document.getElementsByName("quantity")[0];
    var quantity = 0 ;


    if(selectOptionPopupDiv != null ){
        if(selectOptionPopupDiv.style.display == 'block' ){
        leftEyeChoice = selectOptionPopupDiv.getElementsByClassName("left-eye-option")[0].value;
        rightEyeChoice = selectOptionPopupDiv.getElementsByClassName("pg__option__v")[0].value;
        }else{
            leftEyeChoice = leftEyeDiv[0].value;
            rightEyeChoice = rightEyeDiv[0].value;
        }
    }else{
        leftEyeChoice = leftEyeDiv[0].value;
        rightEyeChoice = rightEyeDiv[0].value;
    }

    if(strQuantity != undefined){
        quantity = strQuantity.valueAsNumber ;
    }else{
        quantity = 1;
    }

    console.log("leftEyeChoice", leftEyeChoice);
    console.log("rightEyeChoice", rightEyeChoice);
    console.log("current quantity", quantity);

    
    if(selectOptionPopupDiv != null ){
        if(selectOptionPopupDiv.style.display == 'block' ){
            leftVariantOpt = selectOptionPopupDiv.getElementsByClassName("left-eye-option")[0].options;
            rightVariantOpt = selectOptionPopupDiv.getElementsByClassName("pg__option__v")[0].options;
        }else{
            leftVariantOpt = leftEyeDiv[0].options;
            rightVariantOpt = rightEyeDiv[0].options;
        }
    }else{
        leftVariantOpt = leftEyeDiv[0].options;
        rightVariantOpt = rightEyeDiv[0].options;
    }   

    for (var i = 0; i < leftVariantOpt.length; i++) {
        var leftOpt = leftVariantOpt[i].value
        if (leftOpt == leftEyeChoice) {
            var stock = leftVariantOpt[i].getAttribute("sr")
            leftStockRecord = parseInt(stock);                
        }
   } 
  
  for (var i = 0; i < rightVariantOpt.length; i++) {
        var rightOpt = rightVariantOpt[i].value
        if (rightOpt == rightEyeChoice) {
            var stock = rightVariantOpt[i].getAttribute("sr")
            rightStockRecord = parseInt(stock);  

            //store stock record for right prescription cart validation
            var stockRProp = document.getElementById("stock-record");
            console.log("stockRProp", stockRProp);
            stockRProp.value = stock;
           
        }
   }

    console.log("------STOCK AVAILABLE INHOUSE--------")
    console.log("leftStockRecord inhouse", leftStockRecord);
    console.log("rightStockRecord inhouse", rightStockRecord);

    // Start Compare with cart items
    var currentCartItems = 0;
    if (window.priceTier.cart != null) {
        currentCartItems = window.priceTier.cart.items;
    }
    if (currentCartItems.length > 0) {
        console.log("currentCartItems is more than 0")
        var leftStockOnCart = 0;
        var rightStockOnCart = 0;

        for (var j = 0; j < currentCartItems.length; j++) {
            if (window.priceTier.cart.items[j].product_id == pid){//match with selection
                    var leftContactCart = window.priceTier.cart.items[j].variant_title;
                    var rightContactCart = window.priceTier.cart.items[j].properties[" "];
                    console.log("leftContactCart", leftContactCart);
                    console.log("rightContactCart", rightContactCart);

                    if ( leftContactCart == leftEyeChoice) {
                        //check inventory status
                        leftStockOnCart = leftStockOnCart + window.priceTier.cart.items[j].quantity;
                    }
                    if ( rightContactCart == leftEyeChoice) {
                        //check inventory status
                        leftStockOnCart = leftStockOnCart + window.priceTier.cart.items[j].quantity;
                    }
                    if ( leftContactCart == rightEyeChoice ) {
                        //check inventory status
                        rightStockOnCart = rightStockOnCart + window.priceTier.cart.items[j].quantity;
                    }
                if ( rightContactCart == rightEyeChoice) {
                        //check inventory status
                        rightStockOnCart = rightStockOnCart + window.priceTier.cart.items[j].quantity;
                    }
                }
            }
                console.log("------STOCK ADDED ONCART--------")
                console.log("leftStockOnCart", leftStockOnCart);
                console.log("rightStockOnCart", rightStockOnCart);

                remainingStockLeft = leftStockRecord - leftStockOnCart;
                remainingStockRight = rightStockRecord - rightStockOnCart;

                console.log("------ REMAINING STOCK CAN ADD --------")
                console.log("remainingStockLeft", remainingStockLeft);
                console.log("remainingStockRight", remainingStockRight);

                if(leftEyeChoice == rightEyeChoice){
                    quantity = quantity*2;
                    console.log("leftEyeChoice == rightEyeChoice", quantity)
                }

                if (remainingStockLeft != 0 || remainingStockRight != 0){

                    console.log("remainingStockLeft != 0 && remainingStockRight != 0")
        
                        if(quantity > remainingStockLeft || quantity > remainingStockRight){
        
                            setTimeout(function(){  document.getElementsByClassName('button--single-cart-main')[0].disabled = true;}, 300);     
                            if(callfrom != 'refresh' && callfrom != 'sidecart' && callfrom != 'cart' && callfrom != undefined && callfrom != 'priceTiers'){
                              if(quantity > remainingStockLeft){
                                showAlert(leftStockRecord, leftEyeChoice);
                              }else if(quantity > remainingStockRight){
                                showAlert(rightStockRecord, rightEyeChoice);
                              }
                            }
        
                        }else{
                            document.getElementsByClassName('button--single-cart-main')[0].disabled = false;  
                            hideAlert();
                        }
        
                   }else{
                      //this  lens is not on cart
                      if(quantity > leftStockRecord || quantity > rightStockRecord){
                        setTimeout(function(){  document.getElementsByClassName('button--single-cart-main')[0].disabled = true;}, 300);     
                        if(callfrom != 'refresh' && callfrom != 'sidecart' && callfrom != 'cart' && callfrom != undefined && callfrom != 'priceTiers'){
                          if(quantity > remainingStockLeft){
                            showAlert(leftStockRecord, leftEyeChoice);
                          }else if(quantity > remainingStockRight){
                            showAlert(rightStockRecord, rightEyeChoice);
                          }
                        }
        
                    }else{
                        document.getElementsByClassName('button--single-cart-main')[0].disabled = false;  
                        hideAlert();
                    }
        
                   }


        
    }else{
        console.log("currentCartItems is empty")
        if(leftEyeChoice == rightEyeChoice){
                    quantity = quantity*2;
                    console.log("leftEyeChoice == rightEyeChoice", quantity)
                }

        if(quantity > leftStockRecord || quantity > rightStockRecord){
            setTimeout(function(){  document.getElementsByClassName('button--single-cart-main')[0].disabled = true;}, 300);     
            if(callfrom != 'refresh' && callfrom != 'sidecart' && callfrom != 'cart' && callfrom != undefined && callfrom != 'priceTiers'){
              if(quantity > leftStockRecord){
                showAlert(leftStockRecord, leftEyeChoice);
              }else if(quantity > rightStockRecord){
                showAlert(rightStockRecord, rightEyeChoice);
              }
            }

        }else{
            document.getElementsByClassName('button--single-cart-main')[0].disabled = false;  
            hideAlert();
        }
    }

 }

 if (callfrom == 'priceTiers' || callfrom == 'cart'){

    //Duble check stock validation on cart
    console.log("callling from cart");
    cart = window.priceTier.cart.items;
    
    if (cart.length > 0) {

      var itemId = '';
      var stockR = '';
      var quantity = 0;
      var leftP = '';//window.priceTier.cart.items[0].variant_options[0] 
      var rightP = '';//window.priceTier.cart.items[0].properties[' ']

      for (var i = 0; i < cart.length; i++) {

        var leftP = window.priceTier.cart.items[i].variant_options[0] 
        var rightP = window.priceTier.cart.items[i].properties[' ']

        //window.priceTier.cart.items[0].properties['_StockRecord'] 
        //window.priceTier.cart.items[0].quantity 
        itemQty = window.priceTier.cart.items[i].quantity;
      
        console.log("itemQty", itemQty);
        var stockRString = window.priceTier.cart.items[i].properties['_StockRecord'];
        stockR = parseInt(stockRString);
        stockControl = parseInt(stockRString);
        itemkeyId = window.priceTier.cart.items[i].key;
        var itemLine = i + 1;
        if(leftP == rightP){
          stockR = Math.floor(stockR/2);
          console.log("stockR", stockR);
        }

        if(itemQty > stockR){
          updateCart(itemkeyId, stockR)
          showAlertCart(stockControl, rightP);
     
        }
       
      }
    }  

  } 

}

function updateCart(keyId, qty){
  var formData = new FormData();
  formData.append('id', keyId);
  formData.append('quantity', qty);

  fetch('/cart/change.js', {
    method: 'POST',
    body: formData
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    console.log('Success:', data);
    console.log('data.item_count:', data.item_count);
    document.querySelector(".cart-number.text-center.abs-number").innerHTML= data.item_count;
    document.querySelector(".cart-number.abs-number.cart-number--header").innerHTML= data.item_count;
    setTimeout(refreshCart, 200);
    setTimeout(getCart, 200);
     updateCartObject();
  })
  .catch((error) => {
    console.error('Error:', error);
  }); 
   //fetchCartAgain();

}

function getCart(){
    var url =  "?view=ajax";
    var xhttp= createCORSRequest('GET', url);
  
  
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
      
        
        var shopifysectioncarttemplate = document.getElementById("shopify-section-cart-template");
        if (shopifysectioncarttemplate != null){
            shopifysectioncarttemplate.innerHTML = xhttp.responseText;
        }
        // console.log("xhttp.responseText", xhttp.responseText);
      }
    };
    xhttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhttp.send(); 
  }



function refreshCart(){
  var url =  "/?view=header_cart";
  var xhttp= createCORSRequest('GET', url);


  xhttp.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200) {
      var header__cart_drawer = document.getElementById("header__cart_drawer");
      if (header__cart_drawer != null){
        header__cart_drawer.innerHTML = xhttp.responseText;
      }

      // console.log("xhttp.responseText", xhttp.responseText);
    }
  };
  xhttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  xhttp.send(); 
}

function showAlert(stock, prescription){
  
     var notifyAlert = document.getElementsByClassName("alert")[0];
     notifyAlert.innerText = "You can only add "+stock+" prescription "+prescription+" to the cart."
     removeClass(notifyAlert,"alert-success");
     addClass(notifyAlert,"alert-danger");
      
     notifyAlert.style.display = "block";
     document.getElementsByClassName('button--single-cart-main')[0].style.cursor = "not-allowed";
     setTimeout(hideAlert, 5000);
}

function showAlertCart(stock, prescription){

  
     var notifyAlert = document.getElementsByClassName("alert")[1];

      console.log("notifyAlert", notifyAlert);
     notifyAlert.innerText = "You can only add "+stock+" prescription "+prescription+" to the cart."
     removeClass(notifyAlert,"alert-success");
     addClass(notifyAlert,"alert-danger");
      
     notifyAlert.style.display = "block";
     setTimeout(hideAlertCart, 5000);
}

function hideAlert(){
  
    var notifyAlert = document.getElementsByClassName("alert")[0];
    notifyAlert.innerText = ""
    removeClass(notifyAlert,"alert-danger");
   
      
    notifyAlert.style.display = "none!important";
  
} 

function hideAlertCart(){
  
    var notifyAlert = document.getElementsByClassName("alert")[1];
    notifyAlert.innerText = ""
    removeClass(notifyAlert,"alert-danger");
      
    notifyAlert.style.display = "none!important";
  
} 

